var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient, createApiError } from '../interceptor/interceptor';
// ==========================================
// API SERVICE
// ==========================================
/**
 * Fetch assessment timeline for a patient.
 *
 * @param patientId - Patient ID (required, non-empty string)
 * @returns Promise<TimelineMilestone[]> - Array of milestones
 * @throws ApiError if request fails or patientId is invalid
 */
export const getAssessmentTimeline = (patientId) => __awaiter(void 0, void 0, void 0, function* () {
    // Validate patientId before making API call
    if (!(patientId === null || patientId === void 0 ? void 0 : patientId.trim())) {
        throw createApiError('Patient ID is required', 400);
    }
    const response = yield apiClient.get(`screener/patients/${patientId}/assessment-timeline`);
    return response.data;
});
